import type { HTMLAttributes } from "react";
import { cn } from "@/lib/cn";

/**
 * No existe un componente `ResponsiveTableList` con ese nombre en el
 * original — el patrón real (10 archivos `*Mobile*`) es dos árboles
 * MONTADOS EN PARALELO, uno oculto por CSS según el breakpoint
 * (`visibleFrom="md"` / `hiddenFrom="md"` de Mantine, sin `useMediaQuery`
 * ni detección en JS). `DesktopOnly`/`MobileOnly` codifican esa misma
 * convención en Tailwind — reemplazo directo, breakpoint único `md`
 * (el original a veces usaba `sm`, se unifica a `md` para consistencia
 * con el resto de la migración).
 *
 * Uso típico (par tabla-desktop + card-mobile):
 *   <DesktopOnly><Card>...<Table>...</Table></Card></DesktopOnly>
 *   <MobileOnly className="flex flex-col gap-2">{items.map(...)}</MobileOnly>
 */
export function DesktopOnly({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("hidden md:block", className)} {...props} />;
}

export function MobileOnly({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("block md:hidden", className)} {...props} />;
}
